<form fxLayout="column" fxLayoutGap="100px" [formGroup]="datiFornForm">
  <ng-container formArrayName="richieste">
    <ng-container *ngFor="let richiesta of richieste.controls; index as ri">
      <div fxLayout="row">
        <ng-container *ngIf="ri != 0">
          <div fxLayoutAlign="center center">
            <button mat-icon-button (click)="removeRichiesta(ri)">
              <mat-icon color="warn">remove_circle</mat-icon>
            </button>
          </div>
          <mat-divider class="vertical-divider" [vertical]="true">
          </mat-divider>
        </ng-container>
        <div [formGroupName]="ri" fxLayout="column" fxLayoutGap="30px" fxFlexFill class="div-ri">

          <div>
            <h2 class="title-section">Servizio richiesto</h2>
            <!-- <mat-form-field appearance="fill" fxFlexFill class="selezione-richiesta">
                            <mat-select placeholder="Seleziona richiesta" formControlName="richiesta">
                                <mat-option *ngFor="let item of richiesteList" [value]="item.code"
                                    [disabled]="item.disabled">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="richiesta.hasError('required')">
                                Campo obbligatorio
                            </mat-error>
                        </mat-form-field> -->
            <mat-radio-group formControlName="richiesta" fxLayout="grid wrap" fxLayoutGap="10px">
              <mat-grid-list cols="2" rowHeight="25px" fxFlexFill role="list" class="servizio-grid-list">
                <mat-grid-tile *ngFor="let item of richiesteListFiltered" role="listitem">
                  <mat-radio-button [value]="item.code" [disabled]="item.disabled">{{item.value}}
                  </mat-radio-button>
                </mat-grid-tile>
              </mat-grid-list>
            </mat-radio-group>
          </div>

          <div>
            <h2 class="title-section">Commodity</h2>
            <mat-radio-group formControlName="commodity" fxLayout="row wrap" fxLayoutGap="10px grid">
              <mat-radio-button value="0">Energia elettrica</mat-radio-button>
              <mat-radio-button value="1">Gas naturale</mat-radio-button>
              <mat-radio-button value="2">Energia elettrica + Gas naturale</mat-radio-button>
            </mat-radio-group>
          </div>

          <div fxLayout="row" fxLayoutGap="20px">
            <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="30px" fxFlexFill>
              <ng-container formArrayName="pods">
                <ng-container *ngFor="let pod of pods(richiesta).controls; index as pi">
                  <div [formGroupName]="pi" fxFlexFill>
                    <div fxLayout="row" fxLayoutGap="10px" fxFlexFill>

                      <ng-container *ngIf="pi != 0">
                        <div fxLayoutAlign="center center">
                          <button mat-icon-button (click)="removePod(pi, richiesta)" class="remove-button">
                            <mat-icon color="warn">remove_circle</mat-icon>
                          </button>
                        </div>
                        <mat-divider class="vertical-divider" [vertical]="true">
                        </mat-divider>
                      </ng-container>

                      <div fxLayout="column" fxLayoutGap="10px" fxFlex="auto">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                          <div>
                            <h2 class="divider-title">
                              Dati tecnici
                            </h2>
                          </div>
                          <mat-divider fxFlex="auto"></mat-divider>
                        </div>
                        <div>
                          <form formGroupName="datiTecnici">
                            <div fxLayout="column" fxLayoutGap="20px">
                              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <mat-form-field>
                                  <input [required]="setRequired(pod.get('datiTecnici')!.get('pod'))" matInput formControlName="pod" placeholder="POD" maxlength="14"
                                    oninput="this.value = this.value.toUpperCase()">
                                  <mat-error *ngIf="pod.get('datiTecnici')?.get('pod')?.hasError('pattern')">
                                    Pattern errato
                                  </mat-error>
                                  <mat-error *ngIf="pod.get('datiTecnici')?.get('pod')?.hasError('minlength') || pod.get('pod')?.hasError('maxlength')">
                                    Lunghezza errata
                                  </mat-error>
                                  <mat-error *ngIf="pod.get('datiTecnici')!.get('pod')?.hasError('required')">
                                    Campo obbligatorio
                                  </mat-error>
                                  <mat-error *ngIf="pod.get('datiTecnici')!.get('pod')?.hasError('esisteSE1')">
                                    Punto già presente a sistema
                                  </mat-error>
                                  <mat-error *ngIf="pod.get('datiTecnici')!.get('pod')?.hasError('esisteAOF')">
                                    Punto non presente a sistema
                                  </mat-error>
                                </mat-form-field>
                                <ng-container *ngIf="dataService.prodotto?.tipo_utenza == 'DOM'">
                                  <div>
                                    <h3 class="h3-residente">Tipo di Utilizzo</h3>
                                    <mat-radio-group fxLayout="row" fxLayoutGap="10px" formControlName="residente" [required]="setRequired(pod.get('datiTecnici')!.get('residente'))">
                                      <mat-radio-button value="0">Residente
                                      </mat-radio-button>
                                      <mat-radio-button value="1">Non residente
                                      </mat-radio-button>
                                      <mat-radio-button value="2">Altri usi
                                      </mat-radio-button>
                                      <mat-radio-button value="3">Veicoli elettrici
                                      </mat-radio-button>
                                    </mat-radio-group>
                                  </div>
                                </ng-container>
                              </div>
                              <ng-container *ngIf="altriDatiTecnici.show">
                                <div fxFlex="auto" fxFlexFill fxLayout="row wrap">
                                  <mat-expansion-panel fxFlexFill [expanded]="true" (opened)="altriDatiPanel = true" (closed)="altriDatiPanel = false">
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>
                                        Altri dati *
                                      </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="altri-dati-row">
                                      <ng-container *ngIf="altriDatiTecnici.livelloTensione">
                                        <mat-form-field>
                                          <mat-select placeholder="Livello di tensione" formControlName="livelloTensione" [required]="setRequired(pod.get('datiTecnici')!.get('livelloTensione'))">
                                            <mat-option value="BT">
                                              Bassa tensione
                                            </mat-option>
                                            <mat-option value="MT">
                                              Media tensione
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.tensione">
                                        <mat-form-field>
                                          <mat-select placeholder="Tensione (V)" formControlName="tensione" [required]="setRequired(pod.get('datiTecnici')!.get('tensione'))">
                                            <mat-option value="230">230
                                            </mat-option>
                                            <mat-option value="380">380
                                            </mat-option>
                                            <ng-container *ngIf="tipoUtenza == 'BUS'">
                                              <mat-option value="20000">
                                                20000
                                              </mat-option>
                                            </ng-container>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.potenzaImpegnata">
                                        <mat-form-field>
                                          <mat-select placeholder="Potenza Impegnata" formControlName="potenzaImpegnata" [required]="setRequired(pod.get('datiTecnici')!.get('potenzaImpegnata'))">
                                            <mat-option *ngFor="let pot of _potenzeImpegnate" [value]="pot.value">
                                              {{pot.code}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.potenzaDisponibile">
                                        <mat-form-field>
                                          <input matInput placeholder="Potenza disponibile" formControlName="potenzaDisponibile"
                                            [required]="setRequired(pod.get('datiTecnici')!.get('potenzaDisponibile'))">
                                          <mat-error *ngIf="pod.get('datiTecnici')!.get('potenzaDisponibile')?.hasError('pattern')">
                                            <strong>Inserire un valore
                                              numerico
                                              intero</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.volume">
                                        <mat-form-field>
                                          <input matInput placeholder="Consumo annuo (kWh)" formControlName="volume" [required]="setRequired(pod.get('datiTecnici')!.get('volume'))">
                                          <mat-error *ngIf="pod.get('datiTecnici')!.get('volume')?.hasError('pattern')">
                                            <strong>Inserire un valore numerico intero</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.settoreMerceologico">
                                        <mat-form-field fxFlex="50">
                                          <!-- <mat-select placeholder="Settore merceologico" formControlName="settoreMerceologico"
                                            [required]="setRequired(pod.get('datiTecnici')!.get('settoreMerceologico'))">
                                            <mat-option *ngFor="let item of _settoriMerceologici" [value]="item.code">
                                              {{item.code}} - {{item.description}}
                                            </mat-option>
                                          </mat-select> -->
                                          <bw-autocomplete [required]="setRequired(pod.get('datiTecnici')!.get('settoreMerceologico'))" [source]="_settoriMerceologici" valueMember="code" displayMember="code" [secondLineMember]="secondLineFn"
                                            formControlName="settoreMerceologico" placeholder="Settore merceologico">
                                          </bw-autocomplete>
                                          <mat-error *ngIf="pod.get('datiTecnici')!.get('settoreMerceologico')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.presenzaCliente">
                                        <div fxLayout="column" fxLayoutGap="10px">
                                          <h3>Presenza cliente</h3>
                                          <mat-radio-group fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" formControlName="presenzaCliente"
                                            [disabled]="richieste.at(ri).get('richiesta')?.value != 'N02'">
                                            <mat-radio-button value="0">No
                                            </mat-radio-button>
                                            <mat-radio-button value="1">Si
                                            </mat-radio-button>
                                          </mat-radio-group>
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.tipoVoltura">
                                        <mat-form-field>
                                          <mat-select placeholder="Tipo voltura" formControlName="tipoVoltura" [required]="setRequired(pod.get('datiTecnici')!.get('tipoVoltura'))">
                                            <mat-option *ngFor="let item of tipiVolture" [value]="item.value">
                                              {{item.value}} - {{item.label}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                    </div>
                                    <div *ngIf="altriDatiTecnici.dataDecorrenza || altriDatiTecnici.distributoreEE" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
                                      <ng-container *ngIf="altriDatiTecnici.dataDecorrenza">
                                        <mat-form-field>
                                          <mat-label>Data di decorrenza
                                          </mat-label>
                                          <input [required]="setRequired(pod.get('datiTecnici')?.get('dataDecorrenza'))" matInput [min]="minDecorr" [matDatepicker]="dataDecorrenzaPicker"
                                            formControlName="dataDecorrenza">
                                          <mat-error *ngIf="pod.get('datiTecnici')?.get('dataDecorrenza')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                          <mat-datepicker-toggle matSuffix [for]="dataDecorrenzaPicker">
                                          </mat-datepicker-toggle>
                                          <mat-datepicker #dataDecorrenzaPicker>
                                          </mat-datepicker>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.distributoreEE">
                                        <mat-form-field fxFlex="50">
                                          <mat-select placeholder="Distributore" formControlName="distributore" [required]="setRequired(pod.get('datiTecnici')!.get('distributore'))">
                                            <mat-option class="multiline-mat-option" *ngFor="let item of distributoriEE" [value]="item.id_distributore_id">
                                              <div>{{item.ragione_sociale}}</div>
                                              <div><small>{{item.comune}} ({{item.provincia}}) - {{item.regione}}</small></div>
                                            </mat-option>
                                          </mat-select>
                                          <mat-error *ngIf="pod.get('datiTecnici')!.get('distributore')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                        <mat-icon color="primary" *ngIf="pod.get('datiTecnici')!.get('distributore')?.disabled" [matTooltipHideDelay]="2000"
                                          matTooltip="Il campo si abilita solo dopo aver selezionato un comune nei dati di fornitura">help
                                        </mat-icon>
                                      </ng-container>
                                    </div>
                                    <div *ngIf="altriDatiTecnici.dataFineFornitura || altriDatiTecnici.ctrTempoDeterminato" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
                                      <ng-container *ngIf="altriDatiTecnici.ctrTempoDeterminato">
                                        <div fxLayout="row" class="altri-dati-row">
                                          <div fxFlex="auto">
                                            <h4>
                                              <strong>CTR a tempo determinato</strong> *
                                            </h4>
                                            <mat-radio-group formControlName="ctrTempoDeterminato" fxLayout="column" fxLayoutGap="10px">
                                              <mat-radio-button value="0">No</mat-radio-button>
                                              <mat-radio-button value="1">Si</mat-radio-button>
                                            </mat-radio-group>
                                          </div>
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.dataFineFornitura">
                                        <mat-form-field>
                                          <mat-label>Data fine fornitura
                                          </mat-label>
                                          <input [required]="setRequired(pod.get('datiTecnici')?.get('dataFineFornitura'))" matInput [min]="minFineForn" [matDatepickerFilter]="dateFilter"
                                            [matDatepicker]="dataFineFornituraPicker" formControlName="dataFineFornitura">
                                          <mat-error *ngIf="pod.get('datiTecnici')?.get('dataFineFornitura')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                          <mat-datepicker-toggle matSuffix [for]="dataFineFornituraPicker">
                                          </mat-datepicker-toggle>
                                          <mat-datepicker #dataFineFornituraPicker>
                                          </mat-datepicker>
                                        </mat-form-field>
                                      </ng-container>
                                    </div>
                                  </mat-expansion-panel>
                                </div>
                              </ng-container>
                            </div>
                          </form>
                        </div>
                        <ng-container *ngIf="tipoUtenza == 'BUS'">
                          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                            <div>
                              <h2 class="divider-title">
                                Iva e accise
                              </h2>
                            </div>
                            <mat-divider fxFlex="auto"></mat-divider>
                          </div>
                          <div fxLayout="column" fxLayoutGap="10px">
                            <div>
                              Verrà applicata l'iva al 22% e Greening Energy sarà il
                              sostituto di
                              imposta
                            </div>
                            <div>
                              <mat-checkbox formControlName="checkIvaAgevolata">Iva
                                agevolata
                              </mat-checkbox>
                            </div>
                            <div *ngIf="pod.get('checkIvaAgevolata')!.value">
                              Scaricare il modulo e inviarlo compilato e firmato in
                              secondo
                              momento a clienti&#64;greeningenergy.it
                              <button mat-button color="accent" (click)="downloadDocCompilato()">
                                Scarica
                                <mat-icon>download</mat-icon>
                              </button>
                            </div>
                          </div>
                        </ng-container>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                          <div>
                            <h2 class="divider-title">
                              Dati catastali
                            </h2>
                          </div>
                          <mat-divider fxFlex="auto"></mat-divider>
                        </div>
                        <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="checkDatiCatastali">
                          <mat-radio-button value="0">
                            Ci si impegna a comunicarli in un secondo momento
                          </mat-radio-button>
                          <mat-radio-button value="1">
                            Inserire i dati adesso
                          </mat-radio-button>
                        </mat-radio-group>
                        <form formGroupName="datiCatastali" *ngIf="pod.get('checkDatiCatastali')!.value == '1'">
                          <div fxLayout="row wrap" fxLayoutGap="10px">
                            <mat-form-field>
                              <mat-select placeholder="Codice unità" formControlName="codiceUnita" [required]="setRequired(pod.get('datiCatastali')!.get('codiceUnita'))">
                                <mat-option value="F">Fabbricati</mat-option>
                                <mat-option value="T">Terreni</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-select placeholder="Codice qualifica" formControlName="codiceQualifica" [required]="setRequired(pod.get('datiCatastali')!.get('codiceQualifica'))">
                                <mat-option value="1">Proprietario</mat-option>
                                <mat-option value="2">Usufruttuario</mat-option>
                                <mat-option value="3">Titolare di altro diritto
                                </mat-option>
                                <mat-option value="4">Rappresentante legale o volontario
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Codice catastale" formControlName="codiceCatastale" maxlength="4" [required]="setRequired(pod.get('datiCatastali')!.get('codiceCatastale'))">
                              <mat-error *ngIf="pod.get('datiCatastali')!.get('codiceCatastale')?.hasError('pattern')">
                                Pattern errato
                              </mat-error>
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Sezione" formControlName="sezione" [required]="setRequired(pod.get('datiCatastali')!.get('sezione'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Foglio" formControlName="foglio" [required]="setRequired(pod.get('datiCatastali')!.get('foglio'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Particella" formControlName="particella" [required]="setRequired(pod.get('datiCatastali')!.get('particella'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Subalterno" formControlName="subalterno" [required]="setRequired(pod.get('datiCatastali')!.get('subalterno'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Estensione" formControlName="estensione" [required]="setRequired(pod.get('datiCatastali')!.get('estensione'))">
                            </mat-form-field>
                            <mat-form-field>
                              <mat-select placeholder="Codice particella" formControlName="codiceParticella" [required]="setRequired(pod.get('datiCatastali')!.get('codiceParticella'))">
                                <mat-option value="1">Non applicabile</mat-option>
                                <mat-option value="E">Edificabile</mat-option>
                                <mat-option value="F">Fondiaria</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <mat-form-field fxFlex="40" fxFlex.md="60" fxFlex.sm="60">
                              <mat-select placeholder="Motivazione assenza di dati" formControlName="assenzaDati">
                                <mat-option value="1">Immobile non accatastato
                                </mat-option>
                                <mat-option value="2">Immobile non accatastabile
                                </mat-option>
                                <mat-option value="3">Dati non forniti dal titolare
                                  utenza
                                </mat-option>
                                <mat-option value="4">Forniture per usi pubblici
                                </mat-option>
                                <mat-option value="5">Condominio</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <button fxLayoutAlign="center center" type="button" *ngIf="pod.get('checkDatiCatastali')!.value" matSuffix mat-icon-button aria-label="Cancella"
                              (click)="pod.get('datiCatastali')!.get('assenzaDati')!.patchValue('')">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </form>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                          <div>
                            <h2 class="divider-title">
                              Indirizzo di fornitura
                            </h2>
                          </div>
                          <mat-divider fxFlex="auto"></mat-divider>
                        </div>
                        <div>
                          <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-checkbox formControlName="indirizzoUguale" [matTooltip]="dataService.isIndirizzoEstero$.value ? 'È necessario inserire l\'indirizzo se la residenza è estera' : ''">
                              Indirizzo uguale a quello
                              {{dataService.prodotto?.tipo_utenza
                              == 'DOM' ? 'di residenza': 'legale'}}
                            </mat-checkbox>
                          </div>
                          <div fxLayout="row" fxLayoutGap="10px" *ngIf="dataService.datiAnagrafici?.get('tipoCliente')?.value == '1'">
                            <mat-form-field>
                              <input [required]="setRequired(pod.get('denominazione'))" matInput placeholder="Denominazione" formControlName="denominazione">
                            </mat-form-field>
                          </div>
                          <app-indirizzo [indirizzoForm]="indirizzoForm(pod)"></app-indirizzo>
                        </div>
                      </div>
                    </div>

                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="prodotto!.cod_tipo_fornitura_id != 'GAS' && tipoUtenza == 'BUS'">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <button mat-button (click)="addPod(richiesta)" class="add-pod">
                    <mat-icon color="primary">add_circle</mat-icon>
                    Aggiungi POD
                  </button>
                </div>
              </ng-container>

              <ng-container formArrayName="pdrs">
                <ng-container *ngFor="let pdr of pdrs(richiesta).controls; index as pi">
                  <div [formGroupName]="pi" fxFlexFill>
                    <div fxLayout="row" fxLayoutGap="10px" fxFlexFill>

                      <ng-container *ngIf="pi != 0">
                        <div fxLayoutAlign="center center">
                          <button mat-icon-button (click)="removePdr(pi, richiesta)" class="remove-button">
                            <mat-icon color="warn">remove_circle</mat-icon>
                          </button>
                        </div>
                        <mat-divider class="vertical-divider" [vertical]="true">
                        </mat-divider>
                      </ng-container>

                      <div fxLayout="column" fxLayoutGap="10px" fxFlex="auto">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                          <div>
                            <h2 class="divider-title">
                              Dati tecnici
                            </h2>
                          </div>
                          <mat-divider fxFlex="auto"></mat-divider>
                        </div>
                        <div>
                          <form formGroupName="datiTecnici">
                            <div fxLayout="column" fxLayoutGap="20px">
                              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <mat-form-field>
                                  <input [required]="setRequired(pdr.get('datiTecnici')!.get('pdr'))" matInput formControlName="pdr" placeholder="PDR" maxlength="14"
                                    oninput="this.value = this.value.toUpperCase()">
                                  <mat-error *ngIf="pdr.get('datiTecnici')!.get('pdr')?.hasError('pattern')">
                                    Pattern errato
                                  </mat-error>
                                  <mat-error *ngIf="pdr.get('datiTecnici')?.get('pdr')?.hasError('minlength') || pdr.get('pdr')?.hasError('maxlength')">
                                    Lunghezza errata
                                  </mat-error>
                                  <mat-error *ngIf="pdr.get('datiTecnici')!.get('pdr')?.hasError('required')">
                                    <strong>Campo obbligatorio</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <ng-container *ngIf="altriDatiTecnici.show">
                                <div fxFlex="auto" fxFlexFill fxLayout="row wrap">
                                  <mat-expansion-panel fxFlexFill [expanded]="true" (opened)="altriDatiPanel = true" (closed)="altriDatiPanel = false">
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>
                                        Altri dati *
                                      </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-container *ngIf="altriDatiTecnici.tipoSubentro">
                                      <div fxLayout="row" class="altri-dati-row">
                                        <div fxFlex="auto">
                                          <h3>
                                            <strong>Tipologia di subentro</strong> *
                                          </h3>
                                          <mat-radio-group formControlName="tipoSubentro" fxLayout="column" fxLayoutGap="10px">
                                            <mat-radio-button value="0">A01 - Non soggetta alla disciplina prevista dalla deliberazione n. 40/04
                                            </mat-radio-button>
                                            <mat-radio-button value="1">A40 - Soggetta alla disciplina prevista dalla deliberazione n. 40/04
                                            </mat-radio-button>
                                          </mat-radio-group>
                                        </div>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="altriDatiTecnici.dataDecorrenza">
                                      <mat-form-field>
                                        <mat-label>Data di decorrenza
                                        </mat-label>
                                        <input [required]="setRequired(pdr.get('datiTecnici')?.get('dataDecorrenza'))" matInput [min]="startOfMonth" [matDatepickerFilter]="startMonthDateFilter"
                                          [matDatepicker]="dataDecorrenzaPicker" formControlName="dataDecorrenza">
                                        <mat-error *ngIf="pdr.get('datiTecnici')?.get('dataDecorrenza')?.hasError('required')">
                                          <strong>Campo obbligatorio</strong>
                                        </mat-error>
                                        <mat-datepicker-toggle matSuffix [for]="dataDecorrenzaPicker">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #dataDecorrenzaPicker>
                                        </mat-datepicker>
                                      </mat-form-field>
                                    </ng-container>
                                    <div *ngIf="altriDatiTecnici.dataFineFornitura || altriDatiTecnici.ctrTempoDeterminato" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
                                      <ng-container *ngIf="altriDatiTecnici.ctrTempoDeterminato">
                                        <div fxLayout="row" class="altri-dati-row">
                                          <div fxFlex="auto">
                                            <h4>
                                              <strong>CTR a tempo determinato</strong> *
                                            </h4>
                                            <mat-radio-group formControlName="ctrTempoDeterminato" fxLayout="column" fxLayoutGap="10px">
                                              <mat-radio-button value="0">No</mat-radio-button>
                                              <mat-radio-button value="1">Si</mat-radio-button>
                                            </mat-radio-group>
                                          </div>
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.dataFineFornitura">
                                        <mat-form-field>
                                          <mat-label>Data fine fornitura
                                          </mat-label>
                                          <input [required]="setRequired(pdr.get('datiTecnici')?.get('dataFineFornitura'))" matInput [min]="minFineForn" [matDatepickerFilter]="dateFilter"
                                            [matDatepicker]="dataFineFornituraPicker" formControlName="dataFineFornitura">
                                          <mat-error *ngIf="pdr.get('datiTecnici')?.get('dataFineFornitura')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                          <mat-datepicker-toggle matSuffix [for]="dataFineFornituraPicker">
                                          </mat-datepicker-toggle>
                                          <mat-datepicker #dataFineFornituraPicker>
                                          </mat-datepicker>
                                        </mat-form-field>
                                      </ng-container>
                                    </div>
                                    <div fxLayout="row wrap" fxLayoutAlign="start flex-end" fxLayoutGap="10px" class="altri-dati-row">
                                      <ng-container *ngIf="altriDatiTecnici.consumoAnnuo">
                                        <mat-form-field>
                                          <input matInput placeholder="Consumo annuo (Smc)" formControlName="consumoAnnuo" [required]="setRequired(pdr.get('datiTecnici')!.get('consumoAnnuo'))">
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('consumoAnnuo')?.hasError('pattern')">
                                            <strong>Inserire un valore numerico intero</strong>
                                          </mat-error>
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('consumoAnnuo')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.settoreMerceologico">
                                        <mat-form-field fxFlex="50">
                                          <!-- <mat-select placeholder="Settore merceologico" formControlName="settoreMerceologico"
                                            [required]="setRequired(pdr.get('datiTecnici')!.get('settoreMerceologico'))">
                                            <mat-option *ngFor="let item of _settoriMerceologici" [value]="item.code">
                                              {{item.code}} - {{item.description}}
                                            </mat-option>
                                          </mat-select> -->
                                          <bw-autocomplete [required]="setRequired(pdr.get('datiTecnici')!.get('settoreMerceologico'))" [source]="_settoriMerceologici" valueMember="code" displayMember="code" [secondLineMember]="secondLineFn"
                                            formControlName="settoreMerceologico" placeholder="Settore merceologico">
                                          </bw-autocomplete>
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('settoreMerceologico')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.categoriaUso">
                                        <mat-form-field fxFlex="65">
                                          <mat-select placeholder="Categoria d'uso" formControlName="categoriaUso" [required]="setRequired(pdr.get('datiTecnici')!.get('categoriaUso'))">
                                            <mat-option *ngFor="let item of categorieUsoFiltered" [value]="item.value">
                                              {{item.value}} - {{item.label}}
                                            </mat-option>
                                          </mat-select>
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('categoriaUso')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.potenzaMassimaRichiesta">
                                        <mat-form-field>
                                          <input matInput placeholder="Potenza massima richiesta" formControlName="potenzaMassimaRichiesta"
                                            [required]="setRequired(pdr.get('datiTecnici')!.get('potenzaMassimaRichiesta'))">
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('potenzaMassimaRichiesta')?.hasError('pattern')">
                                            <strong>Inserire un valore numerico intero</strong>
                                          </mat-error>
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('potenzaMassimaRichiesta')?.hasError('max')">
                                            <strong>Non superare il valore massimo di 56</strong>
                                          </mat-error>
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('potenzaMassimaRichiesta')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.distributoreGAS">
                                        <mat-form-field fxFlex="50">
                                          <mat-select placeholder="Distributore" formControlName="distributore" [required]="setRequired(pdr.get('datiTecnici')!.get('distributore'))">
                                            <mat-option class="multiline-mat-option" *ngFor="let item of distributoriGAS" [value]="item.id_distributore_id">
                                              <div>{{item.ragione_sociale}}</div>
                                              <div><small>{{item.comune}} ({{item.provincia}}) - {{item.regione}}</small></div>
                                            </mat-option>
                                          </mat-select>
                                          <mat-error *ngIf="pdr.get('datiTecnici')!.get('distributore')?.hasError('required')">
                                            <strong>Campo obbligatorio</strong>
                                          </mat-error>
                                        </mat-form-field>
                                        <mat-icon color="primary" *ngIf="pdr.get('datiTecnici')!.get('distributore')?.disabled" [matTooltipHideDelay]="2000"
                                          matTooltip="Il campo si abilita solo dopo aver selezionato un comune nei dati di fornitura">help
                                        </mat-icon>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.tipoVoltura">
                                        <mat-form-field>
                                          <mat-select placeholder="Tipo voltura" formControlName="tipoVoltura" [required]="setRequired(pdr.get('datiTecnici')!.get('tipoVoltura'))">
                                            <mat-option *ngFor="let item of tipiVolture" [value]="item.value">
                                              {{item.value}} - {{item.label}}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                      <ng-container *ngIf="altriDatiTecnici.lettura">
                                        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
                                          <h3>Dati ultima lettura</h3>
                                          <div fxLayout="row" fxLayoutGap="10px" formGroupName="lettura">
                                            <mat-form-field>
                                              <mat-label>Data di lettura</mat-label>
                                              <input matInput [matDatepicker]="dataLettura" formControlName="data">
                                              <!-- <mat-error *ngIf="pdr.get('datiTecnici')?.get('dataLettura')?.hasError('required')">
                                                                                                <strong>Campo obbligatorio</strong>
                                                                                            </mat-error> -->
                                              <mat-datepicker-toggle matSuffix [for]="dataLettura">
                                              </mat-datepicker-toggle>
                                              <mat-datepicker #dataLettura>
                                              </mat-datepicker>
                                            </mat-form-field>
                                            <mat-form-field>
                                              <input matInput placeholder="Valore lettura" formControlName="valore">
                                              <!-- <mat-error *ngIf="pdr.get('datiTecnici')!.get('valoreLettura')?.hasError('required')">
                                                                                                <strong>Campo obbligatorio</strong>
                                                                                            </mat-error> -->
                                              <mat-error *ngIf="pdr.get('datiTecnici')!.get('lettura')!.get('valore')?.hasError('pattern')">
                                                <strong>Inserire un valore numerico intero</strong>
                                              </mat-error>
                                            </mat-form-field>
                                          </div>
                                        </div>
                                      </ng-container>
                                    </div>
                                  </mat-expansion-panel>
                                </div>
                              </ng-container>
                            </div>
                          </form>
                        </div>
                        <ng-container *ngIf="tipoUtenza == 'BUS'">
                          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                            <div>
                              <h2 class="divider-title">
                                Iva e accise
                              </h2>
                            </div>
                            <mat-divider fxFlex="auto"></mat-divider>
                          </div>
                          <div fxLayout="column" fxLayoutGap="10px">
                            <div>
                              Verrà applicata l'iva al 22% e Greening Energy sarà il sostituto di imposta
                            </div>
                            <div>
                              <mat-checkbox formControlName="checkIvaAgevolata">Iva agevolata
                              </mat-checkbox>
                            </div>
                            <div *ngIf="pdr.get('checkIvaAgevolata')!.value">
                              Scaricare il modulo e inviarlo compilato e firmato in secondo momento a clienti&#64;greeningenergy.it
                              <button mat-button color="accent">
                                Scarica
                                <mat-icon>download</mat-icon>
                              </button>
                            </div>
                          </div>
                        </ng-container>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                          <div>
                            <h2 class="divider-title">
                              Dati catastali
                            </h2>
                          </div>
                          <mat-divider fxFlex="auto"></mat-divider>
                        </div>
                        <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="checkDatiCatastali">
                          <mat-radio-button value="0">
                            Ci si impegna a comunicarli in un secondo momento
                          </mat-radio-button>
                          <mat-radio-button value="1">
                            Inserire i dati adesso
                          </mat-radio-button>
                        </mat-radio-group>
                        <form formGroupName="datiCatastali" *ngIf="pdr.get('checkDatiCatastali')!.value == '1'">
                          <div fxLayout="row wrap" fxLayoutGap="10px">
                            <mat-form-field>
                              <mat-select placeholder="Codice unità" formControlName="codiceUnita" [required]="setRequired(pdr.get('datiCatastali')!.get('codiceUnita'))">
                                <mat-option value="F">Fabbricati</mat-option>
                                <mat-option value="T">Terreni</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-select placeholder="Codice qualifica" formControlName="codiceQualifica" [required]="setRequired(pdr.get('datiCatastali')!.get('codiceQualifica'))">
                                <mat-option value="1">Proprietario</mat-option>
                                <mat-option value="2">Usufruttuario</mat-option>
                                <mat-option value="3">Titolare di altro diritto
                                </mat-option>
                                <mat-option value="4">Rappresentante legale o volontario
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Codice catastale" formControlName="codiceCatastale" maxlength="4" [required]="setRequired(pdr.get('datiCatastali')!.get('codiceCatastale'))">
                              <mat-error *ngIf="pdr.get('datiCatastali')!.get('codiceCatastale')?.hasError('pattern')">
                                Pattern errato
                              </mat-error>
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Sezione" formControlName="sezione" [required]="setRequired(pdr.get('datiCatastali')!.get('sezione'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Foglio" formControlName="foglio" [required]="setRequired(pdr.get('datiCatastali')!.get('foglio'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Particella" formControlName="particella" [required]="setRequired(pdr.get('datiCatastali')!.get('particella'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Subalterno" formControlName="subalterno" [required]="setRequired(pdr.get('datiCatastali')!.get('subalterno'))">
                            </mat-form-field>
                            <mat-form-field>
                              <input matInput placeholder="Estensione" formControlName="estensione" [required]="setRequired(pdr.get('datiCatastali')!.get('estensione'))">
                            </mat-form-field>
                            <mat-form-field>
                              <mat-select placeholder="Codice particella" formControlName="codiceParticella" [required]="setRequired(pdr.get('datiCatastali')!.get('codiceParticella'))">
                                <mat-option value="1">Non applicabile</mat-option>
                                <mat-option value="E">Edificabile</mat-option>
                                <mat-option value="F">Fondiaria</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <mat-form-field fxFlex="40" fxFlex.md="60" fxFlex.sm="60">
                              <mat-select placeholder="Motivazione assenza di dati" formControlName="assenzaDati">
                                <mat-option value="1">Immobile non accatastato
                                </mat-option>
                                <mat-option value="2">Immobile non accatastabile
                                </mat-option>
                                <mat-option value="3">Dati non forniti dal titolare utenza
                                </mat-option>
                                <mat-option value="4">Forniture per usi pubblici
                                </mat-option>
                                <mat-option value="5">Condominio</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <button fxLayoutAlign="center center" type="button" *ngIf="pdr.get('checkDatiCatastali')!.value" matSuffix mat-icon-button aria-label="Cancella"
                              (click)="pdr.get('datiCatastali')!.get('assenzaDati')!.patchValue('')">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </form>
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
                          <div>
                            <h2 class="divider-title">
                              Indirizzo di fornitura
                            </h2>
                          </div>
                          <mat-divider fxFlex="auto"></mat-divider>
                        </div>
                        <div>
                          <ng-container *ngIf="dataService.prodotto?.cod_tipo_fornitura_id == 'EE/GAS' && pi == 0 else indirizzo_uguale">
                            <div fxLayout="row" fxLayoutAlign="start center">
                              <mat-checkbox formControlName="indirizzoUguale">
                                Indirizzo uguale al POD indicato sopra
                              </mat-checkbox>
                            </div>
                          </ng-container>
                          <ng-template #indirizzo_uguale>
                            <div fxLayout="row" fxLayoutAlign="start center">
                              <mat-checkbox formControlName="indirizzoUguale">
                                Indirizzo uguale a quello {{dataService.prodotto?.tipo_utenza == 'DOM' ? 'di residenza': 'legale'}}
                              </mat-checkbox>
                            </div>
                          </ng-template>
                          <div fxLayout="row" fxLayoutGap="10px" *ngIf="dataService.datiAnagrafici?.get('tipoCliente')?.value == '1'">
                            <mat-form-field>
                              <input [required]="setRequired(pdr.get('denominazione'))" matInput placeholder="Denominazione" formControlName="denominazione">
                            </mat-form-field>
                          </div>
                          <app-indirizzo [indirizzoForm]="indirizzoForm(pdr)"></app-indirizzo>
                        </div>
                      </div>
                    </div>

                    <!-- <mat-error *ngIf="pdr.hasError('required')">
                                <strong>Campo obbligatorio</strong>
                            </mat-error> -->
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="prodotto!.cod_tipo_fornitura_id != 'EE' && tipoUtenza == 'BUS'">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <button mat-button (click)="addPdr(richiesta)" class="add-pod">
                    <mat-icon color="primary">add_circle</mat-icon>
                    Aggiungi PDR
                  </button>
                </div>
              </ng-container>
            </div>
          </div>

        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="dataService.prodotto?.tipo_utenza != 'DOM'">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button (click)="addRichiesta()" class="add-pod">
        <mat-icon color="primary">add_circle</mat-icon>
        Aggiungi richiesta
      </button>
    </div>
  </ng-container>

</form>